// Cart store backed by localStorage (ported from original Bodegón app)
const CART_KEY = 'bodegon_cart';
const CURRENCY_KEY = 'bodegon_currency';

export function getCart() {
  try { const raw = localStorage.getItem(CART_KEY); return raw ? JSON.parse(raw) : []; }
  catch { return []; }
}

export function saveCart(items) {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
  window.dispatchEvent(new Event('cart-updated'));
}

export function addToCart(product, quantity = 1) {
  const cart = getCart();
  if (!product.listing_id || product.quantity_available < quantity) throw new Error('Consulta una oferta disponible para tu ubicación');
  const existing = cart.find((item) => item.product_id === product.id);
  if (existing && existing.listing_id === product.listing_id) {
    if (existing.quantity + quantity > product.quantity_available) throw new Error('No hay suficientes unidades disponibles');
    existing.quantity += quantity;
  }
  else {
    if (existing) cart.splice(cart.indexOf(existing), 1);
    cart.push({
      listing_id: product.listing_id,
      store_id: product.store_id || null,
      seller_name: product.seller_name,
      product_id: product.id,
      product_name: product.name,
      price: product.is_on_sale && product.sale_price ? product.sale_price : product.price,
      image_url: product.image_url,
      quantity,
      is_express: product.is_express,
    });
  }
  saveCart(cart);
}

export function updateCartQuantity(productId, quantity) {
  let cart = getCart();
  if (quantity <= 0) { cart = cart.filter((i) => i.product_id !== productId); }
  else { const item = cart.find((i) => i.product_id === productId); if (item) item.quantity = quantity; }
  saveCart(cart);
}

export function removeFromCart(productId) {
  saveCart(getCart().filter((i) => i.product_id !== productId));
}

export function clearCart() { saveCart([]); }

export function getCartTotal() {
  return getCart().reduce((sum, i) => sum + i.price * i.quantity, 0);
}

export function getCartCount() {
  return getCart().reduce((sum, i) => sum + i.quantity, 0);
}

export function getCurrency() { return localStorage.getItem(CURRENCY_KEY) || 'USD'; }
export function setCurrency(currency) {
  localStorage.setItem(CURRENCY_KEY, currency);
  window.dispatchEvent(new Event('currency-updated'));
}

const RATES = { USD: 1, EUR: 0.92, CAD: 1.36, CUP: 250 };
export function convertPrice(usdPrice, currency) {
  return ((usdPrice || 0) * (RATES[currency] || 1)).toFixed(2);
}
export function getCurrencySymbol(currency) {
  const symbols = { USD: '$', EUR: '€', CAD: 'CA$', CUP: '₱' };
  return symbols[currency] || '$';
}

export const PROVINCES = [
  'La Habana', 'Pinar del Río', 'Artemisa', 'Mayabeque', 'Matanzas',
  'Cienfuegos', 'Villa Clara', 'Sancti Spíritus', 'Ciego de Ávila',
  'Camagüey', 'Las Tunas', 'Holguín', 'Granma', 'Santiago de Cuba',
  'Guantánamo', 'Isla de la Juventud',
];
